<template>
  <div>
    <div style="padding: 0 10px">
    <div class="btnContent">
    <div class="one">
      <img src="../assets/images/bankCard.png" alt="">
    </div>
    <div class="two">
      <div style="font-weight: 700; font-size:16px; font-family: 微软雅黑;color:#646566;">一键登录</div>
      <div style="font-size:14px; color: #606060;">快速查看账单</div>
    </div>
    <div class="three">
      <UPButton
        @click="btnClick"
        class="customBtn"
        :scope="scope"
        v-if="isShow"
      >
       去登录
      </UPButton>
    </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast } from "vant";
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      active: 0,
      xjEtcUrl: "https://h5.mot-jk.com?customerSrc=2&channelNo=ysf",
      scope: "scope.mobile",
      appId:
        process.env.NODE_ENV === "development"
          ? "7b95a36deb6d4a49b007be6bffcb0976"
          : "a23b9a1f299249b4998c09558416148a",
      paramSignature: {},
      isShow: true,
    };
  },
  methods: {
    // 加个判断 如果有token 用户点击登录 提示已登录 点击下方货车ETC
    async btnClick(event, err, result) {
        Toast.loading({
          message: '加载中...',
          duration: 0,
          forbidClick: true,
          overlay: true
        })
      var paramBackend = {
        appId: this.appId,
        nonceStr: "",
        timestamp: "",
        signature: ""
      };
      var paramAccess = {
        appId: this.appId,
        backendToken: "",
        code: "",
        grantType: ""
      };
      var paramMobile = {
        appId: this.appId, // 接入放标识
        openId: "", // 用户标识
        accessToken: "", // 授权访问令牌
        backendToken: "", // 基础服务令牌
      };
      var customerMobile = ''
      await axios
        .post("/gateway/xj-user/v1/ysf/getsignature", this.paramSignature)
        .then(res => {
          const {
            data: { result }
          } = res;
          paramBackend = {
            appId: this.appId,
            nonceStr: result.nonceStr,
            timestamp: result.timestamp,
            signature: result.signature
          };
        });
      await axios
        .post("/open/access/1.0/backendToken", paramBackend)
        .then(res => {
          const {
            data: { params }
          } = res;
          var expiresIn = res.data.params.expiresIn;
          window.localStorage.setItem("token", expiresIn);
          paramMobile.backendToken = params.backendToken;
          paramAccess = {
            appId: this.appId,
            backendToken: params.backendToken,
            code: result.code,
            grantType: "authorization_code"
          };
        });
      await axios.post("/open/access/1.0/token", paramAccess).then(res => {
        const {
          data: { params }
        } = res;
        paramMobile.openId = params.openId;
        paramMobile.accessToken = params.accessToken;
      });
      await axios
        .post("/open/access/1.0/user.mobile", paramMobile)
        .then(res => {
          if (res.data.resp == "00") {
            localStorage.setItem('customerMobile', Base64.encode(res.data.params.mobile))
            Toast.clear()
            Toast({
              message: "授权成功，点击下方货车ETC开始办理",
              duration: 3000,
              forbidClick: true
            });
          } else {
            Toast.clear()
          }
        
        });
    }
  }
};
</script>

<style>

.btnContent {
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 100px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 2px 2px 4px #c3c3c3;
}
.btnContent .one, .two, .three {
  flex: 1;
  line-height: 100px
}
.one img {
  width: 95%;
  height: 95%;
}
.two div {
  height: 36px;
  margin-top: -12px;
}
.customBtn {
  width: 85px !important;
  height: 40px !important;
  margin-left: 20px;
  font-size: 14px !important;
  color: #fff !important;
  background-color: #a6d1ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BtnAuth.vue